import { usePrevNextController } from "ra-core";
import { Link } from "react-router";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";

/**
 * Prev / Next navigation between prospect cards, following the same
 * filter + sort as the prospects list, so the user can walk the whole
 * list without going back out of the card.
 */
export const ProspectPrevNextButtons = ({
  linkType = "show",
}: {
  linkType?: "show" | "edit";
}) => {
  const { hasPrev, hasNext, prevPath, nextPath, index, total } =
    usePrevNextController({ resource: "prospects", linkType });

  return (
    <div className="flex items-center gap-1">
      <Button
        asChild={hasPrev}
        variant="outline"
        size="sm"
        disabled={!hasPrev}
        title="Previous prospect"
      >
        {hasPrev && prevPath ? (
          <Link to={prevPath}>
            <ChevronLeft className="size-4" /> Prev
          </Link>
        ) : (
          <span className="flex items-center gap-1">
            <ChevronLeft className="size-4" /> Prev
          </span>
        )}
      </Button>
      {typeof index === "number" && total ? (
        <span className="px-1 text-xs text-muted-foreground whitespace-nowrap">
          {index + 1} / {total}
        </span>
      ) : null}
      <Button
        asChild={hasNext}
        variant="outline"
        size="sm"
        disabled={!hasNext}
        title="Next prospect"
      >
        {hasNext && nextPath ? (
          <Link to={nextPath}>
            Next <ChevronRight className="size-4" />
          </Link>
        ) : (
          <span className="flex items-center gap-1">
            Next <ChevronRight className="size-4" />
          </span>
        )}
      </Button>
    </div>
  );
};
